import { createHOC } from 'vue-hoc';

import auth from '~lib/common/providers/auth';
import userManagement from '~lib/common/providers/userManagement';
import withUser from '~lib/common/hoc/withUser';

import OrgManagement from './OrgManagement.vue';

const options = {
  name: 'OrgManagementContainer',
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      state: {
        loading: false,
        error: null,
        isKeyOwner: false,
      },
    };
  },
  async created() {
    this.state.isKeyOwner = await userManagement.isKeyOwner();
  },
};

const renderWith = {
  props: {
    error() {
      return this.state.error;
    },
    loading() {
      return this.state.loading;
    },
    isKeyOwner() {
      return this.state.isKeyOwner;
    },
    isAdmin() {
      const role = this.user['https://vrpatients.com/role'];
      return role === 'ADMIN' || role === 'SUPER_ADMIN';
    },
    isAdminOrInstructor() {
      const role = this.user['https://vrpatients.com/role'];
      return role === 'ADMIN' || role === 'SUPER_ADMIN' || role === 'USER';
    },
  },
  listeners: {},
};

const OrgManagementContainer = withUser()(createHOC(OrgManagement, options, renderWith));
export default OrgManagementContainer;
